import smartSolveApi from './instances/smartsolve';

export const getConfigDatasources = async () => {
  try {
    const response = await smartSolveApi.get('/data-sources', {});
    return response.data;
  } catch (e) {
    throw new Error(`getConfigDatasources() failed: ${e}`);
  }
};

export const saveConfigDatasource = async (rows) => {
  try {
    const response = await smartSolveApi.post('/data-sources', rows);
    return response.data;
  } catch (e) {
    throw new Error(`saveConfigDatasource() failed: ${e}`);
  }
};

export const getSourceData = async (source) => {
  try {
    const response = await smartSolveApi.post('/data-sources/data', { source });
    return response.data || [];
  } catch (e) {
    throw new Error(`getSourceData() failed: ${e}`);
  }
};

export const deletConfigDatasource = async (id) => {
  try {
    const response = await smartSolveApi.delete('/data-sources/' + id, {});
    return response.data;
  } catch (e) {
    throw new Error(`deletConfigDatasource() failed: ${e}`);
  }
};

export const exportExcelSourceData = async (source) => {
  try {
    return await smartSolveApi.post(
      '/data-sources/data/excel',
      { source },
      { responseType: 'blob' }
    );
  } catch (e) {
    throw new Error(`getSourceData() failed: ${e}`);
  }
};

export const exportXMLConfigDataSource = async () => {
  try {
    return await smartSolveApi.get('/data-sources/xml', { responseType: 'blob' });
  } catch (e) {
    throw new Error(`getConfigDatasources() failed: ${e}`);
  }
};
